import InstallLicenseTools from '../../pages/InstallLicenseTools'
import { createDescriptor, PageDescriptor } from '../../pages/types'
import RetrieveLocalLicense from '../../pages/RetrieveLocalLicense'
import StartTokenServer from '../../pages/StartTokenServer'
import { ServerBrick } from './ServerBrick'
import { ReactNode } from 'react'
import { Licenses } from '../scenarios/data'

export class TokenServerBrick extends ServerBrick {
    constructor(license: 'fu' | 'fcs', readonly os: string) {
        super(license)
    }

    public describe(): ReactNode
    {
        return <p>The <b>Token Server</b> runs in your environment on a (virtual) machine. 
        Its <b>{Licenses[this.license!].name} license</b> is bound to that specific machine.
        It keeps track of your (concurrent) Gurobi usage.</p>;
    }

    public key(): string { 
        return 'ts'
    }

    public isContainer(): boolean {
        return false
    }

    public isOrchestrated(): boolean {
        return false
    }

    get title(): string {
        return 'Token Server'
    }

    get sortIndex(): number {
        return 1
    }

    *getPages(): Generator<PageDescriptor> {
        const { os } = this
        yield createDescriptor(InstallLicenseTools, { os })
        yield createDescriptor(RetrieveLocalLicense, { })
        yield createDescriptor(StartTokenServer, { os })
    }
}
